import { RouteRecordRaw } from 'vue-router'
import adminAgentRoutes from './admin/agent'

const adminRoutes: RouteRecordRaw[] = [...adminAgentRoutes]

export default adminRoutes
